/**
 * Window selector. Options come from the server so a chip cannot offer a range
 * the server does not cache.
 *
 * The selected chip also states the cache TTL, because that is the honest answer
 * to "how fresh is this?" — the board polls, but the server may be serving a
 * cached aggregation up to an hour old for the 30-day window.
 */
import { rangeLabel, useRange } from '../api/range'
import { age } from './format'
import './RangeChips.css'

export function RangeChips() {
  const { days, setDays, options, ttlSeconds } = useRange()
  return (
    <div className="chips" role="group" aria-label="Time window">
      {options.map((d) => (
        <button key={d} type="button"
                className={`chip${d === days ? ' on' : ''}`}
                aria-pressed={d === days}
                onClick={() => setDays(d)}>
          {rangeLabel(d)}
        </button>
      ))}
      {ttlSeconds > 0 ? (
        <span className="chip-note mono" title="server-side cache lifetime for this window">
          cached {age(ttlSeconds)}
        </span>
      ) : null}
    </div>
  )
}
